import React from 'react';
import SearchPanel from '../components/Search/SearchPanel';

function SearchPage() {
  return (
    <div className="search-page">
      <SearchPanel />
    </div>
  );
}

export default SearchPage;
